import { AxiosInstance } from 'axios';
import * as Sentry from '@sentry/react';
import { config } from 'config';
import { AxiosClient, AxiosUtils } from '../AxiosClient/AxiosClient';
import { WarrantyDesignation } from 'types';

class Labelo {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_LABELO,
      xClientSource: false,
    });
  }

  async getLabelos(customerReference: string): Promise<WarrantyDesignation[]> {
    return this.client
      .get<WarrantyDesignation[]>(`labels?cuRef=${customerReference}`, {
        headers: AxiosClient.getAuthorizationHeader(),
      })
      .then(result => {
        return result.data;
      })
      .catch(error => {
        Sentry.captureException(error, {
          tags: {
            api: 'labelo',
            endpoint: 'labels',
            ...AxiosUtils.enrichTags(error),
          },
        });
        return [];
      });
  }
}

export const LabeloService = new Labelo();
